module.exports = __webpack_public_path__ + "static/media/MainHelp.6ba1747d.svg";